export const SET_TOP_TO_BOTTOM_FILTER_SELECTION = 'SET_TOP_TO_BOTTOM_FILTER_SELECTION';

export default SET_TOP_TO_BOTTOM_FILTER_SELECTION;
